<app-breadcrumb></app-breadcrumb>
<div class="row">
    <div class="col-auto">
        <div class="card mb-0">
            <div class="card-body p-2">
                <div class="fvms-tree">
                    <ul class="fvms-tree-list">
                        <dtg-manage-company-tree
                            [nodeInfo]="{companyInfo:treeRootCompanyInfo}"></dtg-manage-company-tree>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card mb-0">
            <div class="card-body">
                <dtg-manage-company-form></dtg-manage-company-form>
            </div>
        </div>
    </div>
</div>
